module.exports = __webpack_public_path__ + "img/suzuki-swift-boostergreen.5357babe.jpg";